import { useTranslation } from '@/store/languageStore';
import { KeyStatus } from '@/types/locker';
import type { KeyWithVehicle } from '@/types/locker';

const statusStyles: Record<string, string> = {
  [KeyStatus.InCabinet]: 'bg-green-100 border-green-300 text-green-700 dark:bg-green-900/30 dark:border-green-700 dark:text-green-400',
  [KeyStatus.Taken]: 'bg-orange-100 border-orange-300 text-orange-700 dark:bg-orange-900/30 dark:border-orange-700 dark:text-orange-400',
  [KeyStatus.Lost]: 'bg-red-100 border-red-300 text-red-700 dark:bg-red-900/30 dark:border-red-700 dark:text-red-400',
  [KeyStatus.Maintenance]: 'bg-blue-100 border-blue-300 text-blue-700 dark:bg-blue-900/30 dark:border-blue-700 dark:text-blue-400',
  empty: 'bg-gray-100 border-gray-200 text-textTertiary dark:bg-gray-800 dark:border-gray-600 dark:text-textTertiary',
};

interface Props {
  slotNumber: number;
  keyData?: KeyWithVehicle;
  isSelected: boolean;
  onClick: () => void;
  /** Tom tapp eller nyckel som inte får väljas. Klick ignoreras. */
  disabled?: boolean;
}

export default function SlotCircle({ slotNumber, keyData, isSelected, onClick, disabled = false }: Props) {
  const { t } = useTranslation();
  const style = keyData ? (statusStyles[keyData.status] || statusStyles.empty) : statusStyles.empty;
  const dimmed = disabled && Boolean(keyData);

  return (
    <button
      type="button"
      aria-disabled={disabled || undefined}
      onClick={() => {
        if (!disabled) onClick();
      }}
      className={`flex flex-col items-center gap-1 w-[80px] p-2 rounded-md border transition-all flex-shrink-0 ${
        isSelected
          ? 'bg-bgPrimaryLight border-bgPrimary ring-1 ring-bgPrimary/30'
          : disabled
            ? 'border-transparent'
            : 'border-transparent hover:bg-bgBase hover:border-border'
      } ${dimmed ? 'opacity-60' : ''}`}
    >
      <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold border-2 ${style}`}>
        {slotNumber}
      </div>
      {keyData ? (
        keyData.vehicleRegistration ? (
          <span className="text-sm font-semibold text-textPrimary text-center leading-tight max-w-[76px] truncate">
            {keyData.vehicleRegistration}
          </span>
        ) : (
          <>
            <span className="text-sm text-textSecondary text-center leading-tight max-w-[76px] truncate">
              {keyData.name}
            </span>
            <span className="text-sm text-textTertiary">&mdash;</span>
          </>
        )
      ) : (
        <span className="text-sm text-textTertiary">{t('keyManagement.cabinet.emptySlot')}</span>
      )}
    </button>
  );
}
